/**
 * Comutatorul ecranelor de autentificare cu cod (U2).
 *
 * OPRIT implicit, si citit o singura data, aici: `VITE_*` se inline-uieste la
 * BUILD, deci valoarea nu se schimba la runtime — un `if` imprastiat prin
 * componente ar sugera altceva.
 *
 * Cat timp e oprit, rutele nu se inregistreaza deloc (vezi `routes-provider`),
 * deci ecranele nu se pot atinge nici prin URL: catch-all-ul din `main.jsx` le
 * trimite la autentificare.
 *
 * 🔴 Scris EXACT asa, fara cast si fara acces indirect: Vite inlocuieste TEXTUAL
 * `import.meta.env.VITE_...` la build. Forma `(import.meta as {...}).env?.VITE_...`
 * multumeste TypeScript, dar nu se mai potriveste la inlocuire, deci in bundle
 * ramane `undefined` si flagul e mereu oprit — capcana platita la U4, cu o ruta
 * care nu se inregistra si un redirect tacut la autentificare.
 *
 * ⚠️ `src/vite-env.d.ts` declara sase variabile, dar `ImportMetaEnv` are
 * `[key: string]: any` — deci un typo intr-un nume `VITE_*` compileaza si devine
 * `undefined` la runtime. De-aia numele e scris o SINGURA data, aici.
 */
export const AUTENTIFICARE_COD_ACTIVA =
    String(import.meta.env.VITE_AUTENTIFICARE_COD ?? '').toLowerCase() === 'true';
